import React from 'react'
import { Controller } from 'react-hook-form'
import { Content, Error, Field, Label } from './styles'
import { masks } from '../../utils/masks'

export interface InputProps {
  placeholder?: string
  control: any
  label?: string
  button?: any
  type: string
  small?: boolean
  gray?: boolean
  error?: any
  disabled?: boolean
  name: string
  mask?: any
  footerText?: string
  Icon?: any
}

const Input: React.FunctionComponent<InputProps> = ({
  control,
  placeholder,
  label,
  type,
  small,
  button,
  disabled,
  error,
  name,
  gray,
  mask,
  Icon,
}) => {
  return (
    <Controller
      key={name}
      name={name}
      control={control}
      render={({ field: { ref, onChange, onBlur, value, name } }) => {
        const handleOnChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
          let value = e.target.value
          if (mask) {
            value = masks[mask](String(value))
          }
          onChange(value)
        }
        return (
          <div style={{ width: '100%' }}>
            {label && <Label>{label}</Label>}
            <Content gray={gray}>
              <Field
                ref={ref}
                name={name}
                small={small}
                gray={gray}
                disabled={disabled}
                value={value}
                error={!!error}
                onBlur={onBlur}
                autoComplete='new-password'
                onChange={handleOnChange}
                placeholder={placeholder}
                type={type}
              />
              {button && button}

              {Icon && Icon}
            </Content>

            {error && <Error>{error.message}</Error>}
          </div>
        )
      }}
    />
  )
}

export default Input
